export default __webpack_public_path__ + "static/media/logo.73adcd87.svg";